import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface RichTextProps {
    html: string
    className?: string
}

/* Renders a CMS rich text field. Its styles live in src/styles/rich-text.css. */
export const RichText: FC<RichTextProps> = ({ html, className }): ReactNode => {
    return <div className={cn('rich-text', className)} dangerouslySetInnerHTML={{ __html: html }} />
}
